import { Trans } from '@lingui/react'

import type {
  Article,
  Category,
  CategoryListResponseDataItemCustom,
} from '@twisto/api-cms'
import { ForwardIcon } from '@twisto/icons'

import { ContentListLink } from './content-list-link'
import * as styles from './subcategory-content-list.styles'

const RENDER_ITEMS_LIMIT = 5

/*
  Display 5 articles. If subcategories has nested categories display them
  instead of articles.
*/
export const SubcategoryContentList = (
  category: CategoryListResponseDataItemCustom
) => {
  const articles = category.articles as Article[]
  const categories = category.categories as Category[]
  const renderArticles = RENDER_ITEMS_LIMIT - categories.length

  return (
    <ul css={styles.articleList}>
      {categories.slice(0, RENDER_ITEMS_LIMIT).map((category) => (
        <ContentListLink
          key={category.path}
          text={category.name}
          to={category.path}
        />
      ))}
      {articles.slice(0, renderArticles).map((article) => (
        <ContentListLink
          key={article.id}
          text={article.headline}
          to={article.path}
        />
      ))}
      {articles.length > renderArticles && (
        <ContentListLink
          fontWeight="medium"
          text={
            <>
              <Trans
                id="subcategoryList.seeAllArticles"
                values={{ numberOfArticles: articles.length }}
              />{' '}
              <ForwardIcon css={styles.linkIcon} />
            </>
          }
          to={category.path}
        />
      )}
    </ul>
  )
}
